import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AcceptTerms.css';

function AcceptTerms() {
    const [isAccepted, setIsAccepted] = useState(false);
    const [fullName, setFullName] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleAcceptTerms = async () => {
        if (!isAccepted) {
            setError('You must accept the terms and conditions to continue');
            return;
        }

        if (!fullName.trim()) {
            setError('Please enter your full name to accept the agreement');
            return;
        }

        try {
            const response = await fetch('/.netlify/functions/accept-terms', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ fullName: fullName.trim() })
            });

            if (!response.ok) {
                throw new Error('Failed to accept terms');
            }

            navigate('/affiliate');
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className="terms-container">
            <h2>Pep Affiliate Program Agreement</h2>

            <div className="terms-content-wrapper">
                <div className="terms-content">
                    <p>This Pep Affiliate Program Agreement ("Agreement") is made and entered into by and between Pep ("Company") and the individual or entity applying to become an affiliate ("Affiliate"). By participating in the Pep Affiliate Program, you agree to the terms and conditions outlined in this Agreement.</p>

                    <h3>1. Purpose</h3>
                    <p>The purpose of this Agreement is to set the terms under which the Affiliate will promote Pep to generate paid sign-ups using a unique promo code provided by the Company.</p>

                    <h3>2. Enrollment</h3>
                    <p>By enrolling in the Pep Affiliate Program, the Affiliate agrees to adhere to the terms and conditions outlined in this Agreement. The Company reserves the right to accept, reject, or terminate any Affiliate application or participation at its sole discretion, for any reason or no reason.</p>

                    <h3>3. Promotion Guidelines</h3>
                    <p>The Affiliate is authorized to promote Pep using the promo code provided by the Company. The Affiliate agrees to use ethical marketing practices, avoid making false or misleading statements, and comply with all applicable laws and regulations. The Company reserves the right to review and approve any promotional content created by the Affiliate. The Affiliate must immediately comply with any requests from the Company to modify or remove content.</p>

                    <h3>4. Compensation</h3>
                    <p>The Affiliate will earn $15 per paid membership sign-up that is generated from a trial membership conversion using the Affiliate's unique promo code. Compensation is contingent upon the following conditions:</p>
                    <p>The user must convert from a trial to a paid membership.<br />
                        The user must utilize the Affiliate's promo code at the time of sign-up.<br />
                        The user must remain in good standing with the Company, without requesting a refund or engaging in any fraudulent activity.</p>

                    <h3>5. Payment Terms</h3>
                    <p>Payments will be processed on a monthly basis for all confirmed paid memberships generated during the previous month. Payment will only be issued for paid memberships that remain active and in good standing for at least 30 days. The Company reserves the right to adjust or withhold payments for chargebacks, refunds, or fraud detection.</p>

                    <h3>6. Bonuses</h3>
                    <p>As the Company grows, additional bonuses may be introduced for top-performing affiliates at the Company's sole discretion. These bonuses will be communicated in writing and will be governed by the terms outlined in this Agreement.</p>

                    <h3>7. License and Use</h3>
                    <p>The Company grants the Affiliate a limited, non-exclusive, revocable, and non-transferable license to use the Company's trademarks, logos, and promotional materials for the sole purpose of promoting Pep as an Affiliate. The Company reserves the right to revoke this license at any time and for any reason.</p>

                    <h3>8. Content Usage Rights</h3>
                    <p>By participating in the Pep Affiliate Program, the Affiliate grants the Company an irrevocable, perpetual, worldwide, royalty-free, and transferable license to use, reproduce, distribute, and display any promotional content (including images, videos, and written materials) created by the Affiliate related to the Pep Affiliate Program across all channels, including but not limited to social media, websites, email, and advertisements. The Company may modify such content for clarity or promotional purposes while maintaining its integrity.</p>

                    <h3>9. Relationship of Parties</h3>
                    <p>The Affiliate and the Company are independent contractors. Nothing in this Agreement shall be construed as creating an employer-employee relationship, partnership, joint venture, or agency relationship between the parties. The Affiliate does not have any authority to bind the Company.</p>

                    <h3>10. Term and Termination</h3>
                    <p>This Agreement will remain in effect until terminated by either party. Either party may terminate this Agreement at any time, with or without cause, by providing written notice to the other party. Upon termination, the Affiliate must cease all promotion of Pep and remove any promotional materials provided by the Company. The Company may withhold payment for any unpaid commissions if the Affiliate breaches this Agreement.</p>

                    <h3>11. Confidentiality</h3>
                    <p>The Affiliate agrees to maintain the confidentiality of all proprietary and sensitive information disclosed by the Company, including but not limited to product details, marketing strategies, and compensation terms. This obligation remains in effect even after the termination of this Agreement.</p>

                    <h3>12. Limitation of Liability</h3>
                    <p>To the maximum extent permitted by law, the Company will not be liable for any indirect, incidental, or consequential damages arising from the Affiliate's participation in the Pep Affiliate Program, including but not limited to loss of profits, data, or goodwill. The Company's total liability to the Affiliate for any claim related to this Agreement shall not exceed the total compensation paid to the Affiliate in the six months preceding the claim.</p>

                    <h3>13. Indemnification</h3>
                    <p>The Affiliate agrees to indemnify, defend, and hold the Company harmless from any claims, damages, liabilities, costs, or expenses (including attorney fees) arising out of or related to the Affiliate's breach of this Agreement, violation of any law, or improper use of the Company's trademarks and promotional materials.</p>

                    <h3>14. Governing Law</h3>
                    <p>This Agreement shall be governed by and construed in accordance with the laws of Idaho, United States of America without regard to its conflict of law principles.</p>

                    <h3>15. Arbitration</h3>
                    <p>In the event of any dispute or claim arising out of or relating to this Agreement, the parties agree to submit the dispute to binding arbitration. The arbitration shall be conducted in accordance with the rules of the American Arbitration Association (or equivalent in your jurisdiction) and shall take place in Idaho, United States. The decision of the arbitrator(s) shall be final and binding, and judgment may be entered thereon in any court of competent jurisdiction. The parties waive any right to a jury trial or to participate in a class action.</p>

                    <h3>16. Amendments</h3>
                    <p>The Company reserves the right to modify, update, or amend the terms of this Agreement at any time, without prior notice. Notice of any amendments will be provided to the Affiliate, and continued participation in the Pep Affiliate Program will be considered acceptance of the new terms.</p>

                    <h3>17. Entire Agreement</h3>
                    <p>This Agreement constitutes the entire agreement between the parties and supersedes any prior or contemporaneous communications, representations, or agreements, whether oral or written.</p>

                    <h3>18. Severability</h3>
                    <p>If any provision of this Agreement is found to be invalid or unenforceable by a court of competent jurisdiction, the remaining provisions will remain in full force and effect.</p>

                    <h3>19. Signatures</h3>
                    <p>By participating in the Pep Affiliate Program, the Affiliate acknowledges that they have read, understood, and agreed to the terms and conditions of this Agreement.</p>
                </div>
            </div>

            <div className="acceptance-section">
                <div className="name-input-section">
                    <label htmlFor="fullName">Full Name:</label>
                    <input
                        type="text"
                        id="fullName"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        placeholder="Enter your full legal name"
                        required
                    />
                </div>

                <label className="checkbox-label">
                    <input
                        type="checkbox"
                        checked={isAccepted}
                        onChange={(e) => setIsAccepted(e.target.checked)}
                    />
                    <span>I have read and accept the Pep Affiliate Program Agreement</span>
                </label>

                {error && <p className="error">{error}</p>}

                <button
                    className="accept-button"
                    onClick={handleAcceptTerms}
                    disabled={!isAccepted || !fullName.trim()}
                >
                    Accept and Continue
                </button>
            </div>
        </div>
    );
}

export default AcceptTerms;